import { ButtonAsLink } from '@cluey/cluey-components';
import { ReactNode } from 'react';

export interface EnrolmentCardDetailProps {
  renderIcon: ReactNode;
  description: string;
  actionLabel: string;
  onActionClicked: () => void;
  hideAction?: boolean;
  disableAction?: boolean;
}

function EnrolmentCardDetail(props: EnrolmentCardDetailProps) {
  const { renderIcon, description, actionLabel, onActionClicked, hideAction = false, disableAction = false } = props;

  return (
    <div className="grid grid-cols-12 items-center gap-x-3 gap-y-1 py-5 md:flex md:flex-row">
      <div className="col-span-3 h-8 w-8 items-center md:flex">{renderIcon}</div>
      <div className="col-span-9 flex-grow items-center md:flex">{description}</div>
      <div className="col-start-4 col-end-12 items-center md:flex">
        {!hideAction && (
          <ButtonAsLink
            onClick={onActionClicked}
            disabled={disableAction}
            className="text-left md:text-right lg:min-w-[192px]"
          >
            <p className="font-[Proxima-Soft] font-bold uppercase text-link hover:text-orange-500">{actionLabel}</p>
          </ButtonAsLink>
        )}
      </div>
    </div>
  );
}

export default EnrolmentCardDetail;
